import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  totalItems: 0,
  totalPrice: 0,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { product, quantity = 1 } = action.payload;
      const existingItem = state.items.find(
        (item) =>
          item.part_number === product.part_number && item.api_partner === product.api_partner,
      );

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.items.push({
          ...product,
          quantity,
          addedAt: new Date().toISOString(),
        });
      }

      // Recalculate totals
      state.totalItems = state.items.reduce((total, item) => total + item.quantity, 0);
      state.totalPrice = state.items.reduce((total, item) => {
        const price = item.price?.price_list?.[0]?.price || 0;
        return total + price * item.quantity;
      }, 0);
    },
    removeFromCart: (state, action) => {
      const { part_number, api_partner } = action.payload;
      state.items = state.items.filter(
        (item) => !(item.part_number === part_number && item.api_partner === api_partner),
      );

      // Recalculate totals
      state.totalItems = state.items.reduce((total, item) => total + item.quantity, 0);
      state.totalPrice = state.items.reduce((total, item) => {
        const price = item.price?.price_list?.[0]?.price || 0;
        return total + price * item.quantity;
      }, 0);
    },
    updateQuantity: (state, action) => {
      const { part_number, api_partner, quantity } = action.payload;
      const item = state.items.find(
        (item) => item.part_number === part_number && item.api_partner === api_partner,
      );

      if (item) {
        item.quantity = quantity;
        if (item.quantity <= 0) {
          state.items = state.items.filter((i) => i !== item);
        }
      }

      // Recalculate totals
      state.totalItems = state.items.reduce((total, item) => total + item.quantity, 0);
      state.totalPrice = state.items.reduce((total, item) => {
        const price = item.price?.price_list?.[0]?.price || 0;
        return total + price * item.quantity;
      }, 0);
    },
    clearCart: (state) => {
      state.items = [];
      state.totalItems = 0;
      state.totalPrice = 0;
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
